import { useState } from 'react';
import { TextGradient } from '../components/ui/TextGradient';
import { FlipWords } from './ui/FlipWords';
import { MovingBorder } from '../components/ui/moving-borders';
import MagicButton from './ui/magic-buttton';
import WhiteButton from './ui/WhiteButton';
import ResumeButton from './ui/ResumeButton';
import ResumeButton2 from './ui/ResumeButton2';
import { motion } from 'framer-motion';
import ResumeButton22 from './ui/ResumeButton22';
import ResumeButton1 from './ui/ResumeButton1';
import Popup from './Popup';
import { LineShadowText } from './ui/lineShadow';
import { useContext } from 'react';
import { ThemeContext } from './ThemeContext';
import { FiGithub, FiInstagram, FiLinkedin, FiMail, FiTwitter } from 'react-icons/fi';
import { FaTwitter, FaXTwitter } from 'react-icons/fa6';



export default function HeroSection() {
  const { isLight } = useContext(ThemeContext);
  const isDark = !isLight;
  const [isPopupOpen, setIsPopupOpen] = useState(false);

  const togglePopup = () => {
    setIsPopupOpen(!isPopupOpen);
  };

  const animationProps = {
    initial: { opacity: 0, y: 20 },
    whileInView: { opacity: 1, y: 0 },
    viewport: { once: false, amount: 0.9 },
    transition: { duration: 1.5, delay: 0.01 }
  };

  const animationProps2 = {
    initial: { opacity: 0, y: -20 },
    whileInView: { opacity: 1, y: 0 },
    viewport: { once: false, amount: 0.9 },
    transition: { duration: 1.0, delay: 0.0 }
  };

  const handleScroll = () => {
    const element = document.getElementById('contact');
    if (element) {
      const elementTop = element.getBoundingClientRect().top + window.scrollY;
      console.log('Scrolling to:', elementTop); // Check if it's finding the element and calculating the scroll position
      window.scrollTo({
        top: elementTop - 120,
        behavior: 'smooth',
      });
    } else {
      console.log('Element with id "contact" not found.');
    }
  };

  const words = ["React", "Frontend", "Tailwind", "UI/UX", "SEO", "Website"];



  return (
    <div id='home' className="min-h-screen flex flex-col -z-10 items-center justify-center gap-16 py-4">
      {/* First text block */}
      <div className="h-[120vh] w-full dark:bg-black bg-white dark:bg-grid-white/[0.06] bg-grid-black-100/[0.06] absolute top-0 left-0 flex items-center justify-center">
        <div className="absolute pointer-events-none inset-0 flex items-center justify-center dark:bg-black bg-white [mask-image:radial-gradient(ellipse_at_center,transparent_25%,black)]" />
      </div>

      <Popup isOpen={isPopupOpen} onClose={togglePopup} />

      {/* Second text block */}
      <div className="flex flex-col z-10 md:pt-32 sm:pt-24 pt-20 items-center justify-center max-w-4xl text-center">
        <motion.h1 {...animationProps2} className="text-4xl sm:text-45xl lg:text-7xl lg:px-0 bg-clip-text text-transparent bg-gradient-to-b from-neutral-800 to-neutral-900 dark:from-neutral-300 dark:to-zinc-50 tracking-tight font-bold flex flex-wrap justify-center items-center gap-1 sm:gap-2 leading-tight sm:leading-snug " style={{ position: "relative" }}>
          Looking for{" "}
          <TextGradient colors={[
            "#5B9BD5",  // Steel Blue
            "#6495ED",  // Cornflower Blue
            "#4682B4",  // Soft Blue
            "#7EC8E3",  // Medium Baby Blue
            "#4169E1",  // Royal Blue
            "#FF69B4",  // Hot Pink
            "#FF1493",  // Deep Pink
            "#FF6EB4",  // Blush Pink
            "#FF85A1",  // Coral Pink
            "#FF72CF",
            "#5B9BD5",  // Steel Blue
            "#6495ED",  // Cornflower Blue  // Bubblegum Pink

          ]

          } animationSpeed={35} className="text-4xl sm:text-45xl lg:text-7xl lg:px-2 px-1 lg:pr-5 font-bold">
            Problem
          </TextGradient>{" "}
          <span className="bg-clip-text italic text-transparent bg-gradient-to-b from-neutral-800 to-neutral-900 dark:from-neutral-300 dark:to-zinc-200">solver</span>
          <span className="bg-clip-text text-transparent bg-gradient-to-b from-neutral-800 to-neutral-900 dark:from-neutral-300 dark:to-zinc-200">&</span> <FlipWords className={'pl-2'} words={words} />{" "}
          <span className='px-2 lg:py-3 bg-clip-text text-transparent bg-gradient-to-b from-neutral-800 to-neutral-900 dark:from-neutral-300 dark:to-zinc-300'>expert</span>
        </motion.h1>

        <motion.p {...animationProps} className="text-center text-[#333333] z-30 dark:text-zinc-400 font-normal max-w-3xl mx-auto tracking-wider lg:my-2.5 my-1.5 mb-5 lg:mb-6 text-xs sm:text-sm md:text-base lg:text-xl px-4">
          Building scalable web applications with thoughtful architecture and smooth user experience.
          Engineered to last, not just to launch.
        </motion.p>

        <div className='flex justify-center flex-row lg:gap-6 gap-3 sm:gap-4 items-center flex-wrap'>
          {/* Resume Button triggers popup */}
          <div className='dark:hidden block' onClick={togglePopup}>
            <ResumeButton22 text={'View Resume'} />
          </div>
          <div className='dark:block hidden' onClick={togglePopup}>
            <ResumeButton2 text={'View Resume'} />
          </div>
          <div className='dark:block hidden' onClick={handleScroll}>
            <ResumeButton text={'Hire Me'} />
          </div>
          <div className='dark:hidden block' onClick={handleScroll}>
            <ResumeButton1 text={'Hire Me'} />
          </div>
        </div>

        {/* Popup Modal */}

        {/* Social Links */}
        <motion.div
          className="flex flex-row pt-8 justify-center items-center lg:space-x-6 space-x-7"
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
          variants={{
            hidden: { opacity: 0 },
            visible: {
              opacity: 1,
              transition: {
                staggerChildren: 0.1,
                delayChildren: 0.3,
              }
            }
          }}
        >
          {[
            { Icon: FiGithub, href: "https://github.com/VKoder" },
            { Icon: FiLinkedin, href: "https://www.linkedin.com/in/vivek-khule-237682250/" },
            { Icon: FiTwitter, href: "https://x.com/VivekKhule" },
            { Icon: FiInstagram, href: "https://www.instagram.com/vivekk.dev/" },
            { Icon: FiMail, href: "mailto:vivekkhule07@gmail.com" },
          ].map(({ Icon, href }, index) => (
            <motion.a
              key={index}
              href={href}
              target="_blank"
              variants={{
                hidden: { opacity: 0, y: 20 },
                visible: { opacity: 1, y: 0 }
              }}
              whileHover={{ scale: 1.15 }}
              whileTap={{ scale: 0.95 }}
              className="dark:text-zinc-100 text-zinc-900 transition-colors hover:text-blue-500 dark:hover:text-blue-400"
            >
              <Icon className="text-2xl md:text-3xl" />
            </motion.a>
          ))}
        </motion.div>

      </div>

      <style jsx global>{`
        @keyframes gradient {
          0% {
            background-position: 0% 50%;
          }
          100% {
            background-position: 100% 50%;
          }
        }
      `}</style>
    </div>
  );
}
